import { setDateRange, setGuests, setLocation } from 'features/bookingSlice';
import moment from 'moment';

// booking.ts

export const handleLocationChange = (
  location,
  setLocationInputValue,
  dispatch
) => {
  setLocationInputValue(location);
  dispatch(setLocation(location));
};

export const handleDateRangeChange = (
  dateRange,
  setDateRangeValue,
  dispatch
) => {
  setDateRangeValue(dateRange);
  const serializedRange = {
    startDate: dateRange.startDate ? moment(dateRange.startDate) : null,
    endDate: dateRange.endDate ? moment(dateRange.endDate) : null,
  };
  dispatch(setDateRange(serializedRange));
};

export const handleGuestsChange = (
  data,
  setGuestValue,
  dispatch
) => {
  const guests = {
    guestAdults: data.guestAdults ?? 0,
    guestChildren: data.guestChildren ?? 0,
    guestInfants: data.guestInfants ?? 0,
  };
  setGuestValue(guests);
  dispatch(setGuests(guests));
};

// Get Initial value if there's any

export const setInitialValues = (
  haveDefaultValue,
  defaultDateRange,
  defaultLocationValue,
  defaultGuestValue,
  location, // Add location argument
  dateRange, // Add dateRange argument
  guests, // Add guests argument
  setLocationInputValue,
  setDateRangeValue,
  setGuestValue,
  dispatch
) => {
  if (haveDefaultValue) {
    setDateRangeValue(defaultDateRange);
    setLocationInputValue(defaultLocationValue);
    setGuestValue(defaultGuestValue);
  } else {
    if (location || dateRange || guests) {
      setDateRangeValue(dateRange);
      setLocationInputValue(location);
      setGuestValue(guests);
    }
  }
};
